import 'angular';

import { TireconnectLocationCtrl }    from './tireconnect.location';
import { TireConnectStates }          from './tireconnect.states.ajs';
import { TireconnectSettingsCtrl }    from './tireconnect.settings';
import { TireconnectSettingsService } from './tireconnect.settings.service';

angular.module('workshop.tireconnect', [])
.config(TireConnectStates)
.controller('TireconnectLocationCtrl', TireconnectLocationCtrl)
.controller('TireconnectSettingsCtrl', TireconnectSettingsCtrl)
.factory('TireconnectSettings', TireconnectSettingsService);
